<template>
  <div class="mb-3 mb-md-0">
    <div @click="click" v-b-popover.hover.focus.bottom="popup" :class="['bubble-container','d-none d-md-flex', {'selected': selected}, {'force-icon': hasNoLabel}]">
      <span class="label"><slot name="label">{{label}}</slot></span>
      <span class="icon"><slot name="icon"><img :src="icon" /></slot></span>
      <!-- <div v-if="!noDescription" class="bubble-popin">
        <slot name="description">{{description}}</slot>
      </div> -->
    </div>
    <div @click="touch" :class="['bubble-container small-version d-flex d-md-none', {'selected': selected}, {'touched': touched}, {'force-icon': hasNoLabel}]">
      <span class="label"><slot name="label">{{label}}</slot></span>
      <span ref="icon" class="icon"><slot name="icon"><img :src="icon" /></slot></span>
    </div>
    <div @click="removeTouch" v-if="!noDescription" class="bubble-popin d-block d-sm-none">
      <slot name="description">{{description}}</slot>
    </div>
  </div>
</template>

<script>
import anime from 'animejs'
export default {
  name: 'bubble-item',
  props: {
    value: String,
    label: String,
    description: {
      type: [String, Object],
      default: ''
    },
    icon: String,
    selected: Boolean,
    noDescription: {
      type: Boolean,
      default: false
    },
    animate: {
      type: Boolean,
      default: false
    },
    extra: {
      default: undefined
    },
    id: {}
  },
  data () {
    return {
      offset: 0,
      touched: false,
      animation: undefined
    }
  },
  computed: {
    hasNoLabel () {
      return this.label.length === 0
    },
    popup () {
      if (!this.noDescription) {
        if (typeof this.description === 'string') {
          return {
            content: this.description,
            offset: this.offset
          }
        } else {
          return {
            content: (this.description.image.startsWith('http') ? `<span class="preview-desc"><img src="${this.description.image}" /></span>` : '').concat(`<span class="description-text">${this.description.text}</span>`),
            html: true,
            offset: this.offset
          }
        }
      }
      return {
        offset: this.offset
      }
    }
  },
  methods: {
    removeTouch () {
      this.touched = false
    },
    touch () {
      if (this.animate) {
        // this.$refs.icon
        if (!this.animation) {
          this.animation = anime({
            targets: this.$refs.icon,
            rotate: '0.5turn',
            duration: 500,
            easing: 'linear',
            loop: false
          })
        } else {
          this.animation.restart()
        }
      }
      this.touched = !this.touched
      this.$emit('touch', { ...this.$props, removeTouch: this.removeTouch })
    },
    click () {
      this.$emit('click', this.$props)
    }
  }
}
</script>

<style lang="scss">

  $enable-shadows: true;
  @import '~bootstrap/scss/_mixins';
  @import '~bootstrap/scss/_functions';
  @import '~bootstrap/scss/_variables';
  @import '@/assets/scss/_variables.scss';

  .bubble-container {
    position: relative;
    font-family: 'Open Sans', sans-serif;
    width: 150px;
    min-width: 150px;
    height: 150px;
    background-color: $bubbleBg;
    border-radius: 50%;
    border: solid $mainColor;
    color: $mainColor;
    font-size: 14px;
    line-height: 1.4em;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;

    transition-property: background-color box-shadow margin-top height;
    transition-duration: .5s;
    transition-timing-function: ease;

    @include box-shadow($box-shadow);

    .icon {
      display: none;
      // width: 70%;
      // height: 80%;
      img{
        max-width: 70%;
        max-height: 70%;
      }

      img[src*=".svg"] {
        width: 80%;
        height: 80%;
      }
    }

    &.selected{
      background: $mainColor;
      color: #ffffff;
      @media screen and (min-width: map-get($grid-breakpoints,md)){
        margin-top: 2em;
      }
    }

    &:hover{

      @media screen and (min-width: map-get($grid-breakpoints,md)){
        margin-top: 2em;
      }

      background: $mainColor;
      .label {
        display: none;
      }
      .icon {
        display: block;
      }
      .bubble-popin{
        display: block;
        opacity: 1;
      }
    }

    &.force-icon{
      background: $mainColor;
      &.selected{
        background: #0b575f;
      }
      .icon{
        display: block;
      }
    }

    &.small-version{
      width: auto;
      max-width: 100%;
      border-radius: 1em;
      min-height: 70px;
      height: auto;

      &.touched{
        &+ .bubble-popin.d-block {
          display: block !important;
        }
      }

      .icon {
        img{
          max-width: 70%;
          max-height: 70px;
        }

        img[src*=".svg"] {
          width: 80%;
          height: 80%;
        }
      }
    }

  }

  .bubble-popin.d-block {
    display: none !important;
    background-color: #ffffff;
    margin-top: -1em;
    padding: 2em 0.5em 1em 0.5em;
    border-radius: 10px;
    width: 96%;
    margin-left: auto;
    margin-right: auto;
    overflow: hidden;
  }
</style>
